import { COMBO_ES_MX } from "./combo";
import { supplies } from "./supplies";
import { bars } from "./bars";
import { grabAndGo } from "./grab-and-go";
import { duplicateMountableProduct } from "./duplicate-mountable-product";
import { XLSX_PICKER_ES_MX } from "./xlsx-picker";
import { newAndEditProduct } from "./new-and-edit-product";
import { beerDispenser } from "./beer-dispenser";
import { personalizationSettings } from "./personalization-settings";
import { cmv } from "./cmv";
import { productArea } from "./product-area";
import { productDetail } from "./product-detail";
import { technicalSheet } from "./technical-sheet";
import { productList } from "./product-list";
import { productForm } from "./product-form";
import { IMPORT_PRODUCTS_XLSX_ES_MX } from "./import-products-xlsx";

export const products = {
	barMultiSelect: {
		stock: "Stock",
		printerIp: "IP Impresora",
		addAll: "Agregar todos",
		removeAll: "Eliminar todos",
	},
	productArea,
	productDetail,
	technicalSheet,
	duplicateMountableProduct,
	productForm,
	productsTab: {
		tabTitle: "Productos",
		searchLabel: "Buscar",
		searchPlaceholder: "Buscar productos...",
		productsByCategory: "Productos por Categoría",
		sortByCategory: "Organizar por categoría",
		sortByMenuCategory: "Organizar por categoría del menú",
		checkAllItems: "Seleccionar todos los productos ({{counter}})",
		uncheckAllItems: "Desmarcar todos productos ({{counter}})",
		addProductButton: "Agregar Producto",
		exportToExcelButton: "Exportar a Excel",
		importProductsButton: "Importar productos",
		syncWithDelivery: "Sincronizar con delivery",
		editProductsViaExcel: "Editar productos vía Excel",
		buttonDownloadQrCodes: "Descargar QR codes",
		downloadQrCodeAppSell: "Descargar QR codes de venta para el Zig App",
		editProducts: "Editar Productos",
		deleteProducts: "Eliminar productos",
		deleteSelectedProducts: "Eliminar Seleccionados",
		filters: {
			status: {
				all: "Todos",
				active: "Activo",
				inactive: "Inactivo",
			},
		},
		table: {
			activeBars: "Bares Activos",
			name: "Producto",
			fiscalData: "Datos Fiscales",
			mountableDescription: "Producto Montable",
			hasProductionRule: "Ficha Técnica",
			value: "Precio",
			active: "Activado",
			actions: "Acciones",
			edit: "Editar",
			duplicate: "Duplicar producto montable",
			delete: "Quitar",
			yesOption: "Sí",
			noOption: "No",
			onDeleteProductMessage: "¿Desea eliminar el producto {{productName}}?",
			variable: "Variable",
			fiscalCode: "SKU",
		},
		onDeleteMessage: {
			title_one: "¿Desea eliminar {{counter}} producto?",
			title_other: "¿Desea eliminar {{counter}} productos?",
			content: "¡Atención! Los productos serán eliminados permanentemente.",
			okText: "Sí",
			cancelText: "No",
		},
		syncModal: {
			title: "Sincronizar productos",
			syncButton: "Sincronizar",
			chooseYourMenusMultiSelect: "Elija sus menús",
			chooseTheVariablesCheckbox: {
				title:
					"Elija las variables que serán sincronizadas para productos ya registrados en el delivery:",
				all: "Todos",
				price: "Precio",
				category: "Categoría",
				subcategory: "Subcategoría",
				order: "Orden",
				picture: "Foto",
				name: "Nombre",
				description: "Descripción",
				mountableItems: "Elementos montables",
			},
			activeSyncOptionCheckbox: "Activar los productos sincronizados para venta delivery",
			alertMessage:
				"Los productos que no están en el delivery serán creados con las mismas informaciones",
			successFeedback: "¡Éxito, todos los productos sincronizados!",
			warningFeedback: "Algunos productos tuvieron problemas de sincronía.",
			warningFeedbackTable: {
				type: "Tipo",
				description: "Descripción",
			},
		},
		importModal: {
			import: "Importar",
			downloadSheet: "Descargar hoja de cálculo",
			buttonText: "Elegir hoja de cálculo",
			title: "Importar dispositivos de hoja de cálculo",
			sheetFileName: "Productos",
			activateProduct: "Activar productos importados",
			alertMessage:
				"¡Atención! El valor de los productos se informa en centavos, ej: 123 equivale a $ 1,23",
			table: {
				columns: {
					product: "Producto",
					error: "Error",
					description: "Descripción",
				},
				errors: {
					invalidTaxData: "Datos fiscales",
					ncm: "NCM",
					cest: "CEST",
					duplicatedFiscalCode: "SKU duplicado",
					productNotFound: "Producto no encontrado",
					categoryWithSubcategory: "Categoría",
					supercategoryNotFound: "Tipo del producto",
					name: "Nombre",
					category: "Categoría",
					hasAlcohol: "Contiene alcohol",
					isHiddenFromApp: "Ocultar producto",
					value: "Precio",
					kind: "Tipo del producto",
					beerAbv: "ABV - Contenido alcohólico",
					other: "Desconocido",
				},
				errorsDescription: {
					name: "Nombre del producto no informado",
					category: "Categoría del producto no informada",
					hasAlcohol: "El campo debe ser verdadero o falso",
					isHiddenFromApp: "El campo debe ser verdadero o falso",
					value: "El precio del producto es inválido",
					kind: "El tipo del producto es inválido",
					beerAbv: "ABV - Contenido alcohólico debe ser un número",
					other: "Error desconocido",
				},
			},
		},
		xlsxPicker: XLSX_PICKER_ES_MX,
		getTitleDialogActive: "Activar producto",
		getTitleDialogDisable: "Desactivar producto",
		getDescriptionDialogActive:
			"¿Desea activar este producto en los productos montables que lo componen?",
		getDescriptionDialogDisable:
			"¿Desea desactivar este producto en los productos montables que lo componen?",
		findFiscalGroupError: "Grupo fiscal registrado no encontrado",
		findFiscalProfileError: "Perfil fiscal registrado no encontrado",
		productWithoutCategory: "Productos sin categoría del menú",
		onDeleteSelectProductsError: "¡Ups! Un problema ocurrió, intente nuevamente",
		testEmission: {
			titleSuccess: "Probando datos fiscales - Éxito",
			titleError: "Ups, encontramos algunos errores",
			titleTesting: "Probando datos fiscales",
			updating: "Actualizando productos...",
			testing: "Probando {{currentTest}}/{{length}}",
			loadingText: "Aguarde, estamos probando los productos seleccionados",
			success: "Datos fiscales probados con éxito",
			successDescription: "No se encontró ningún error en los datos presentados",
		},
		activeAllQuestion: "¿Activar todos?",
		disableAllQuestion: "¿Desactivar todos?",
		activeAll: "Activar todos",
		disableAll: "Desactivar todos",
		testFiscalData: "Probar datos fiscales",
		limitOver: "Límite arriba de {{limit}} seleccionados",
		deleteSelect: "Eliminar Seleccionados",
		manageProducts: "Gestión de productos",
		managePlaceProducts: "Gestione los productos del local",
	},
	newAndEditProduct,
	editProducts: {
		title: "Editar Producto",
		categoryChange: "Cambiar categoría:",
		categoryNone: "Ninguna",
		typeChange: "Cambiar tipo:",
		typeNone: "Ninguno",
		save: "Guardar",
		confirm: "¿Desea modificar los siguientes productos?",
	},
	combo: COMBO_ES_MX,
	supplies,
	bars,
	grabAndGo,
	beerDispenser,
	personalizationSettings,
	cmv,
	productFeatureForm: {
		validateMessage: "Este campo es obligatorio.",
		typeHere: "Digite aquí...",
		selectHere: "Seleccione aquí...",
		templatesOptionsPlaceholder: "Seleccione el modelo",
		org: "ORG",
		zig: "ZIG",
		observation: "Observación",
		fields: "Campos",
	},
	productList,
	importProductsXlsx: IMPORT_PRODUCTS_XLSX_ES_MX,
};
